module.exports = __webpack_public_path__ + "media/images/apple_wallet-2c6adf3c0ce01c1367b1ce7aef909bb0.jpg";